<template>
  <el-input
    v-model="comment"
    :disabled="disabled"
    size="small"
    type="textarea"
    :rows="2"
    @change="onCommentChange"
  >
  </el-input>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
        required: false,
      },
      itemComment: {
        type: String,
        default() {
          return '';
        },
        required: false,
      },
    },
    data() {
      return {
        comment: '',
      };
    },
    watch: {
      itemComment: {
        handler(comment) {
          this.comment = comment;
        },
        deep: true
      }
    },
    mounted() {
      this.comment = this.itemComment;
    },
    methods: {
      onCommentChange(comment) {
        this.$emit('change', comment);
      }
    }
  };
</script>
